import React from 'react';
import { Box, Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { themeColors } from '../App';

const TermsOfUse = () => {
  return (
    <Box sx={{ py: 8, bgcolor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        {/* Breadcrumbs */}
        <Breadcrumbs 
          sx={{ 
            mb: 4,
            '& .MuiBreadcrumbs-separator': {
              color: themeColors.primary
            }
          }}
        >
          <Link 
            component={RouterLink} 
            to="/"
            sx={{ 
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { color: themeColors.primary }
            }}
          >
            Home
          </Link>
          <Typography color={themeColors.primary}>Terms of Use</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Typography 
          variant="h2" 
          sx={{ 
            mb: 4,
            fontWeight: 700,
            background: 'linear-gradient(135deg, #1a472a 0%, #2e7d32 50%, #4caf50 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Terms of Use
        </Typography>

        <Paper 
          elevation={0}
          sx={{ 
            p: 4, 
            mb: 4, 
            borderRadius: 2,
            border: '1px solid rgba(0,0,0,0.1)',
            background: 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography variant="h6" sx={{ mb: 3, color: themeColors.primary }}>
            Last Updated: March 1, 2025
          </Typography>

          <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', lineHeight: 1.8 }}>
            Please read these Terms of Use ("Terms") carefully before using the website and services of Vibhuti Industries Pvt. Ltd. ("Company," "we," "us," or "our"). By accessing or using our website, you agree to be bound by these Terms.
          </Typography>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              By accessing or using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please do not use our website or services.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              2. Intellectual Property Rights
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary', lineHeight: 1.8 }}>
              All content on this website, including but not limited to:
            </Typography>
            <ul style={{ color: 'rgba(0,0,0,0.6)', lineHeight: 1.8 }}>
              <li>Text, graphics, logos, and images</li>
              <li>Technical specifications and documentation</li>
              <li>Product designs and information</li>
              <li>Website design and layout</li>
            </ul>
            <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.8 }}>
              is the property of Vibhuti Industries Pvt. Ltd. and is protected by applicable intellectual property laws. Any unauthorized use may violate copyright, trademark, and other laws.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              3. Use License
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary', lineHeight: 1.8 }}>
              Permission is granted to temporarily access and view the materials on our website for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </Typography>
            <ul style={{ color: 'rgba(0,0,0,0.6)', lineHeight: 1.8 }}>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose</li>
              <li>Remove any copyright or proprietary notations</li>
              <li>Transfer the materials to another person</li>
              <li>Attempt to decompile or reverse engineer any software</li>
            </ul>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              4. Disclaimer
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              The materials on our website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              5. Limitations
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              In no event shall Vibhuti Industries Pvt. Ltd. or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              6. Accuracy of Materials
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              The materials appearing on our website could include technical, typographical, or photographic errors. We do not warrant that any of the materials on our website are accurate, complete, or current. We may make changes to the materials contained on our website at any time without notice.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              7. Governing Law
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              These Terms shall be governed by and construed in accordance with the laws of India, and you submit to the non-exclusive jurisdiction of the state and federal courts located in Haryana for the resolution of any disputes.
            </Typography>
          </Box>

          <Box sx={{ mb: 6 }}>
            <Typography variant="h5" sx={{ mb: 2, color: themeColors.primary, fontWeight: 600 }}>
              8. Contact Information
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              For any questions about these Terms, please contact us at:
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.8 }}>
              Vibhuti Industries (India) Pvt. Ltd.<br />
              <Link
                href="https://maps.google.com/?q=E-143+Sector-63+Noida+Uttar+Pradesh+201301"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: themeColors.primary,
                    textDecoration: 'underline'
                  }
                }}
              >
                E-143, Sector-63, Noida,<br />
                Gautam Buddha Nagar, Uttar Pradesh - 201301, India
              </Link><br />
              <Link
                href="mailto:legal@vibhutiindustries.com"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: themeColors.primary,
                    textDecoration: 'underline'
                  }
                }}
              >
                Email: legal@vibhutiindustries.com
              </Link><br />
              Phone: {' '}
              <Link
                href="tel:+919999922657"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: themeColors.primary,
                    textDecoration: 'underline'
                  }
                }}
              >
                +91-9999922657
              </Link>
              {' / '}
              <Link
                href="tel:+919667674397"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: themeColors.primary,
                    textDecoration: 'underline'
                  }
                }}
              >
                9667674397
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfUse;
